module.exports = __webpack_public_path__ + "img/reserved.ac67c6e3.svg";